/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Read_PathInputs */

const en_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading project file from path...`)
};

const fr_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture du fichier projet depuis le chemin...`)
};

const de_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektdatei wird vom Pfad gelesen...`)
};

const it_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettura del file di progetto dal percorso...`)
};

const ru_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтение файла проекта из указанного пути...`)
};

const es_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo archivo de proyecto desde la ruta...`)
};

const zh_cn2_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从路径读取项目文件...`)
};

const ja_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスからプロジェクト ファイルを読み込んでいます...`)
};

const hi_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस पथ से प्रोजेक्ट फ़ाइल पढ़ी जा रही है...`)
};

const pt_pt2_load_project_file_status_read_path = /** @type {(inputs: Load_Project_File_Status_Read_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo o arquivo do projeto a partir do caminho...`)
};

/**
* | output |
* | --- |
* | "Reading project file from path..." |
*
* @param {Load_Project_File_Status_Read_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_read_path = /** @type {((inputs?: Load_Project_File_Status_Read_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Read_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_read_path(inputs)
	if (locale === "de") return de_load_project_file_status_read_path(inputs)
	if (locale === "it") return it_load_project_file_status_read_path(inputs)
	if (locale === "ru") return ru_load_project_file_status_read_path(inputs)
	if (locale === "es") return es_load_project_file_status_read_path(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_read_path(inputs)
	if (locale === "ja") return ja_load_project_file_status_read_path(inputs)
	if (locale === "hi") return hi_load_project_file_status_read_path(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_read_path(inputs)
	return en_load_project_file_status_read_path(inputs)
});